import { addToast } from '@mobi/component-library/Feedback/Toast'

export const FeedbackWithdrawalChannelChange = () => {
  addToast({
    id: 'withdrawal-channel-change',
    isDismissable: true,
    title: 'Your withdrawal request may take up to two days to reach your bank account.',
    icon: 'info',
    timeoutMs: 6_000, // 6s
  })
}
